module.exports = __webpack_public_path__ + "static/media/logo_cards_primary.e9f88244.png";